import ConfirmDialog from "@/components/ui/ConfirmDialog";

type Item = { childId: number; childLabel: string; peerName: string };

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  items: Item[];
  roleLabel?: string;
  isPending?: boolean;
};

/**
 * Lead-level assign will revoke the same role on listed deals — {@link ConfirmDialog} shell.
 */
export default function CrossLevelSwapConfirmModal({
  open,
  onClose,
  onConfirm,
  items,
  roleLabel,
  isPending,
}: Props) {
  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title="Replace on applications?"
      tone="destructive"
      warningTitle="Assignees on these deals will be removed"
      warningDescription={
        <>
          Assigning as lead user{roleLabel ? ` (${roleLabel})` : ""} will
          remove the current holder of this role from the following
          application(s).
        </>
      }
      confirmLabel="Remove from deals & assign"
      loadingLabel="Working…"
      isLoading={isPending}
      size="md"
    >
      {items.length > 0 && (
        <ul className="list-disc pl-5 text-xs text-[#1e302a] space-y-1 border border-red-100 rounded-lg bg-red-50/40 p-3">
          {items.map((i) => (
            <li key={i.childId}>
              <span className="font-medium">{i.childLabel}</span>
              <span className="text-[#697571]"> — {i.peerName}</span>
            </li>
          ))}
        </ul>
      )}
    </ConfirmDialog>
  );
}
